<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Seleccione sus opciones</v-toolbar-title
              >
            </v-toolbar>
            <botones-acuerdo-mecanizado
              :key="botonesUsuario"
            ></botones-acuerdo-mecanizado>
            <grid-ultimo-acuerdo-mecanizado
              :key="ultimoAcuerdo"
            ></grid-ultimo-acuerdo-mecanizado>
            <!-- TABLA DOCUMENTO -->
            <template>
              <grid-documento-diario-acuerdo
                :key="gridDocumento"
                :rowsTable="rowsTable"
              ></grid-documento-diario-acuerdo>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import BotonesAcuerdoMecanizado from "@/modules/mecanizado/views/acuerdo/BotonesAcuerdoMecanizado.vue";
import GridUltimoAcuerdoMecanizado from "@/modules/mecanizado/views/acuerdo/GridUltimoAcuerdoMecanizado.vue";
import GridDocumentoDiarioAcuerdo from "@/modules/mecanizado/views/acuerdo/GridDocumentoDiarioAcuerdo.vue";
import VisitaSubTab from "@/modules/visitas/views/VisitaSubTab.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "menu-sub-proceso-mecanizado",

  components: {
    GridDocumentoDiarioAcuerdo,
    BotonesAcuerdoMecanizado,
    GridUltimoAcuerdoMecanizado,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      tabs: ["Acuerdo", "Progreso", "Contingencia", "Calidad"],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      botonesUsuario: 0,
      ultimoAcuerdo: 10,
      gridDocumento: 20,
      idEstado: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {},

  methods: {
    reloadAcuerdo() {
      this.ultimoAcuerdo += 11;
    },
    reloadBoton() {
      this.botonesUsuario += 1;
    },
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
    filterDoc() {
      this.filter = true;
    },
  },
};
</script>
